export default __webpack_public_path__ + "static/media/img5pic3.25010b2a.png";